

export default function openFilter(def,offset,prefix){
    console.log(def.toJS());
    var field = def.get("name");
    var filterWindow = this.dataGet(prefix+"/openFilterData");

    this.dsClear();
    if(filterWindow != null && filterWindow.field == field && filterWindow.open == true){
        this.dsAdd("set",prefix+"/openFilterData",{},"openFilterData");
    }else{
        var data = {
            open:true,
            field,
            def,
            offset,
        }
        this.dsAdd("set",prefix+"/openFilterData",data,"openFilterData");
    }
    this.dsProcess();

    /*
    this.dataSet(prefix+"/openFilterData/def",def);

   
    const akce = {
        type: "OPENFILTER",
        listViewPrefix: prefix,
        filter: filter,
      }
    this.dataSetCustom(akce);
      */
}